import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";
import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import { ServiceDeliveryStatus } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { BookingServicesDto } from "../../../../features/Booking-Form/typings/booking.types";

export type UpdateServicesDto = {
  bookingId: string;
  bookingType: BookingType;
  deliveryStatus: ServiceDeliveryStatus;
  servicesInfo: BookingServicesDto[];
};

export function useRemoteUpdateBookingServicesByUser() {
  return useRemoteMutation<void, RemoteApiError, UpdateServicesDto[]>({
    key: ["booking-service-update-booking-services"],
    url: "/booking-services/update-booking-services-by-user",
    method: "put"
  });
}
